<template>
  <div class="dialog-mask order-filters-dialog" :class="{ open: isOpen }">
    <div class="dialog-content" :style="isMobile ? 'max-width: 95vw' : 'width: 20rem;min-width:20rem'">
      <div class="dialog-header">{{ 'Filters' | lang }}</div>
      <div class="dialog-body" style="overflow: visible">
        <div class="floating-label">
          <select v-model="filtersInternal.Status">
            <option :value="null">{{ 'AllM' | lang }}</option>
            <option v-for="status in statusOptions" :key="status.key" :value="status.key">{{status.value}}</option>
          </select>
          <label>{{ 'Status' | lang }}</label>
        </div>
        <div style="margin-top:50px"  class="floating-label">
          <div class="input-container">
            <!-- <vue-range-slider style="margin-bottom:1rem" :min="amountBounds.min" :max="amountBounds.max" v-model="filtersInternal.Amount" :formatter="formatterAmount" :tooltip-merge="true" :enable-cross="true"  :lazy="false" tooltip-dir="bottom" :tooltip-style="tooltipStyle" :process-style="processStyle" :start-animation="false" v-if="false"></vue-range-slider> -->
            <histogram-slider
              v-if="width"
              style="margin: 0 auto"
              :width="width"
              :bar-height="30"
              :data="allPrices"
              :prettify="prettifyPrice"
              :drag-interval="true"
              :force-edges="false"
              :min="minPrice"
              :max="maxPrice"
              :keyboard="false"
              @change="changePriceBounds"
            />
          </div>
          <label>{{ 'OrderAmount' | lang }}</label>
        </div>
        <div style="margin-top:50px"  class="floating-label">
          <div class="input-container">
            <!-- <vue-range-slider style="margin-bottom:1rem" :min="dateBounds.min" :max="dateBounds.max" v-model="filtersInternal.Date" :formatter="formatterDate" :tooltip-merge="true" :enable-cross="true" :lazy="false" tooltip-dir="bottom" :tooltip-style="tooltipStyle" :process-style="processStyle" :start-animation="false"></vue-range-slider> -->
            <histogram-slider
              v-if="width"
              style="margin: 0 auto"
              :width="width"
              :bar-height="30"
              :data="allDates"
              :prettify="prettify"
              :drag-interval="true"
              :force-edges="false"
              :min="new Date(minDate).valueOf()"
              :max="new Date(maxDate).valueOf()"
              :keyboard="false"
              @change="changeDateBounds"
            />
          </div>
          <label>{{ 'Date' | lang }}</label>
        </div>
      </div>
      <div style="margin-top:50px" class="dialog-footer">
        <!-- <button @click="reset">{{ 'Reset' | lang }}</button> -->
        <button @click="confirm">{{ 'Apply' | lang }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import dialogMixin from '@/mixins/dialogMixin'
import moment from 'moment'
// import VueRangeSlider from 'vue-range-component'
// import 'vue-range-component/dist/vue-range-slider.css'

// Creare componente custom da https://codepen.io/joanneccwang/pen/zYqdLNz ?

import HistogramSlider from 'vue-histogram-slider'
import 'vue-histogram-slider/dist/histogram-slider.css'

export default {
  name: 'FiltriStoricoAcquisti',
  mixins: [ dialogMixin ],
  props: ['filters', 'statusOptions', 'amountBounds', 'dateBounds',
  'allDates', 'allPrices'],
  components: { /* VueRangeSlider, */ HistogramSlider },
  computed: {
    minDate () {
      return Math.min(...this.allDates)
    },
    maxDate () {
      return Math.max(...this.allDates)
    },
    minPrice () {
      return Math.min(...this.allPrices)
    },
    maxPrice () {
      return Math.max(...this.allPrices)
    },
    width () {
      if (this.mounted) {
        return this.$el.children[0].getBoundingClientRect().width *0.7
      }
      return 0
    }
  },
  data () {
    return {
      mounted: false,
      filtersInternal: {},
      dtCache: {},
      tooltipStyle: {
        'background-color': 'var(--white)',
        'border-color': 'var(--primary)',
        'color': 'var(--primary)'
      },
      processStyle: {
        'background-color': 'var(--primary)'
      }
    }
  },
  methods: {
    changePriceBounds (evt) {
      this.filtersInternal.Amount = [evt.from, evt.to]
    },
    changeDateBounds (evt) {
      console.log(evt)
      this.filtersInternal.Date = [new Date(evt.from).toISOString().slice(0, 10), new Date(evt.to).toISOString().slice(0, 10)]
    },
    prettify (value) {
      return new Date(value).toLocaleDateString("it", {
        year: "numeric",
        month: "short",
        day: "numeric",
      })
    },
    prettifyPrice (value) {
      return (value/100).toFixed(2) + '€'
    },
    reset () {
      this.filtersInternal = {
        Status: null,
        Amount: [this.amountBounds.min, this.amountBounds.max],
        Date: [this.dateBounds.min, this.dateBounds.max]
      }
    },
    confirm () {
      this.sweetClose(this.filtersInternal)
    },
    formatterAmount (v) {
      return this.$options.filters.currency(`${(v/100).toFixed(2)}`)
    },
    formatterDate (v) {
      if (this.dtCache[v]) {
        return this.dtCache[v]
      }
      this.dtCache[v] = moment([2010, 0, 1]).add(v, 'days').format('DD/MM/YYYY')
      return this.dtCache[v]
    }
  },
  mounted () {
    // this.filtersInternal = JSON.parse(JSON.stringify(this.filters))
    this.reset()
    this.mounted = true
  },
  watch: {
    filters (newV) {
      this.filtersInternal = JSON.parse(JSON.stringify(newV))
    }
  }
}
</script>

<style>

</style>
